import { PRODUCTS_PROJECT_CONFIG } from '~/constants/products';

export const BlackFridaySidebarKey = 'black_friday_deal';
export const BlackFridayPath = '/black-friday';
export const BlackFridayProductId =
  PRODUCTS_PROJECT_CONFIG.ANNUAL_SUB_OFFER_80_USD_365_DAYS_ID;
export const UserExtraFieldKeyBlackFriday = 'black_friday_2025';
export const BlackFridayPurchaseSource = 'black_friday_2025';
export const BLACK_FRIDAY_SHOW_MODAL_PATH_ALLOW_LIST = [
  '/home',
  '/tools',
  '/ai_researcher',
  '/image_generation',
  '/chat',
];
